module.exports = __webpack_public_path__ + "static/img/sad.3940bc25.png";